// @flow
import { fetchPatientData } from './patientActions';
import { SERVER_ADDRESS, fetchPost } from '../util/actionsUtil';

export const UPDATE_SOCIAL_HISTORY_LOADING = 'UPDATE_SOCIAL_HISTORY_LOADING';
export const UPDATE_SOCIAL_HISTORY_SUCCESS = 'UPDATE_SOCIAL_HISTORY_SUCCESS';
export const UPDATE_SOCIAL_HISTORY_ERROR = 'UPDATE_SOCIAL_HISTORY_ERROR';

export function updateSocialHistory(patientId: string, socialHistory: Object) {
  return ((dispatch: Function) => {
    fetchPost(
      `${SERVER_ADDRESS}/informationHistory/updateSocialHistory`,
      {
        ...socialHistory,
        patientId,
      },
      (data) => {
        dispatch({
          type: UPDATE_SOCIAL_HISTORY_SUCCESS,
          data,
        });
        dispatch(fetchPatientData(patientId));
      },
      (error) => {
        dispatch({
          type: UPDATE_SOCIAL_HISTORY_ERROR,
          error: error.message || error.toString(),
        });
      },
    );
    dispatch({
      type: UPDATE_SOCIAL_HISTORY_LOADING,
    });
  });
}

export const UPDATE_GENERAL_INFO_LOADING = 'UPDATE_GENERAL_INFO_LOADING';
export const UPDATE_GENERAL_INFO_SUCCESS = 'UPDATE_GENERAL_INFO_SUCCESS';
export const UPDATE_GENERAL_INFO_ERROR = 'UPDATE_GENERAL_INFO_ERROR';

export function updateGeneralInfo(patientId: string, generalInfo: Object) {
  return ((dispatch: Function) => {
    fetchPost(
      `${SERVER_ADDRESS}/informationHistory/updateGeneralInfo`,
      {
        ...generalInfo,
        patientId,
      },
      (data) => {
        dispatch({
          type: UPDATE_GENERAL_INFO_SUCCESS,
          data,
        });
        dispatch(fetchPatientData(patientId));
      },
      (error) => {
        dispatch({
          type: UPDATE_GENERAL_INFO_ERROR,
          error: error.message || error.toString(),
        });
      },
    );
    dispatch({
      type: UPDATE_GENERAL_INFO_LOADING,
    });
  });
}

export const ADD_HOUSE_HISTORY_LOADING = 'ADD_HOUSE_HISTORY_LOADING';
export const ADD_HOUSE_HISTORY_SUCCESS = 'ADD_HOUSE_HISTORY_SUCCESS';
export const ADD_HOUSE_HISTORY_ERROR = 'ADD_HOUSE_HISTORY_ERROR';

export function addHouseHistory(patientId: string, houseHistory: Object) {
  return ((dispatch: Function) => {
    fetchPost(
      `${SERVER_ADDRESS}/informationHistory/addHouseHistory`,
      {
        ...houseHistory,
        patientId,
      },
      (data) => {
        dispatch({
          type: ADD_HOUSE_HISTORY_SUCCESS,
          data,
        });
        dispatch(fetchPatientData(patientId));
      },
      (error) => {
        dispatch({
          type: ADD_HOUSE_HISTORY_ERROR,
          error: error.message || error.toString(),
        });
      },
    );
    dispatch({
      type: ADD_HOUSE_HISTORY_LOADING,
    });
  });
}

export const UPDATE_HOUSE_HISTORY_LOADING = 'UPDATE_HOUSE_HISTORY_LOADING';
export const UPDATE_HOUSE_HISTORY_SUCCESS = 'UPDATE_HOUSE_HISTORY_SUCCESS';
export const UPDATE_HOUSE_HISTORY_ERROR = 'UPDATE_HOUSE_HISTORY_ERROR';

export function updateHouseHistory(patientId: string, houseHistory: Object) {
  return ((dispatch: Function) => {
    fetchPost(
      `${SERVER_ADDRESS}/informationHistory/updateHouseHistory`,
      {
        ...houseHistory,
        patientId,
      },
      (data) => {
        dispatch({
          type: UPDATE_HOUSE_HISTORY_SUCCESS,
          data,
        });
        dispatch(fetchPatientData(patientId));
      },
      (error) => {
        dispatch({
          type: UPDATE_HOUSE_HISTORY_ERROR,
          error: error.message || error.toString(),
        });
      },
    );
    dispatch({
      type: UPDATE_HOUSE_HISTORY_LOADING,
    });
  });
}

export const DELETE_HOUSE_HISTORY_LOADING = 'DELETE_HOUSE_HISTORY_LOADING';
export const DELETE_HOUSE_HISTORY_SUCCESS = 'DELETE_HOUSE_HISTORY_SUCCESS';
export const DELETE_HOUSE_HISTORY_ERROR = 'DELETE_HOUSE_HISTORY_ERROR';

export function deleteHouseHistory(patientId: string, houseHistoryId: string) {
  return ((dispatch: Function) => {
    fetchPost(
      `${SERVER_ADDRESS}/informationHistory/deleteHouseHistory`,
      {
        houseHistoryId,
        patientId,
      },
      (data) => {
        dispatch({
          type: DELETE_HOUSE_HISTORY_SUCCESS,
          data,
        });
        dispatch(fetchPatientData(patientId));
      },
      (error) => {
        dispatch({
          type: DELETE_HOUSE_HISTORY_ERROR,
          error: error.message || error.toString(),
        });
      },
    );
    dispatch({
      type: DELETE_HOUSE_HISTORY_LOADING,
    });
  });
}


export const ADD_HOSPITALIZATION_HISTORY_LOADING = 'ADD_HOSPITALIZATION_HISTORY_LOADING';
export const ADD_HOSPITALIZATION_HISTORY_SUCCESS = 'ADD_HOSPITALIZATION_HISTORY_SUCCESS';
export const ADD_HOSPITALIZATION_HISTORY_ERROR = 'ADD_HOSPITALIZATION_HISTORY_ERROR';

export function addHospitalizationHistory(patientId: string, hospitalizationHistory: Object) {
  return ((dispatch: Function) => {
    fetchPost(
      `${SERVER_ADDRESS}/informationHistory/addHospitalizationHistory`,
      {
        ...hospitalizationHistory,
        patientId,
      },
      (data) => {
        dispatch({
          type: ADD_HOSPITALIZATION_HISTORY_SUCCESS,
          data,
        });
        dispatch(fetchPatientData(patientId));
      },
      (error) => {
        dispatch({
          type: ADD_HOSPITALIZATION_HISTORY_ERROR,
          error: error.message || error.toString(),
        });
      },
    );
    dispatch({
      type: ADD_HOSPITALIZATION_HISTORY_LOADING,
    });
  });
}

export const UPDATE_HOSPITALIZATION_HISTORY_LOADING = 'UPDATE_HOSPITALIZATION_HISTORY_LOADING';
export const UPDATE_HOSPITALIZATION_HISTORY_SUCCESS = 'UPDATE_HOSPITALIZATION_HISTORY_SUCCESS';
export const UPDATE_HOSPITALIZATION_HISTORY_ERROR = 'UPDATE_HOSPITALIZATION_HISTORY_ERROR';

export function updateHospitalizationHistory(patientId: string, hospitalizationHistory: Object) {
  return ((dispatch: Function) => {
    fetchPost(
      `${SERVER_ADDRESS}/informationHistory/updateHospitalizationHistory`,
      {
        ...hospitalizationHistory,
        patientId,
      },
      (data) => {
        dispatch({
          type: UPDATE_HOSPITALIZATION_HISTORY_SUCCESS,
          data,
        });
        dispatch(fetchPatientData(patientId));
      },
      (error) => {
        dispatch({
          type: UPDATE_HOSPITALIZATION_HISTORY_ERROR,
          error: error.message || error.toString(),
        });
      },
    );
    dispatch({
      type: UPDATE_HOSPITALIZATION_HISTORY_LOADING,
    });
  });
}

export const DELETE_HOSPITALIZATION_HISTORY_LOADING = 'DELETE_HOSPITALIZATION_HISTORY_LOADING';
export const DELETE_HOSPITALIZATION_HISTORY_SUCCESS = 'DELETE_HOSPITALIZATION_HISTORY_SUCCESS';
export const DELETE_HOSPITALIZATION_HISTORY_ERROR = 'DELETE_HOSPITALIZATION_HISTORY_ERROR';

export function deleteHospitalizationHistory(patientId: string, hospitalizationHistoryId: string) {
  return ((dispatch: Function) => {
    fetchPost(
      `${SERVER_ADDRESS}/informationHistory/deleteHospitalizationHistory`,
      {
        hospitalizationHistoryId,
        patientId,
      },
      (data) => {
        dispatch({
          type: DELETE_HOSPITALIZATION_HISTORY_SUCCESS,
          data,
        });
        dispatch(fetchPatientData(patientId));
      },
      (error) => {
        dispatch({
          type: DELETE_HOSPITALIZATION_HISTORY_ERROR,
          error: error.message || error.toString(),
        });
      },
    );
    dispatch({
      type: DELETE_HOSPITALIZATION_HISTORY_LOADING,
    });
  });
}

export const ADD_SIGNIFICANT_HISTORY_LOADING = 'ADD_SIGNIFICANT_HISTORY_LOADING';
export const ADD_SIGNIFICANT_HISTORY_SUCCESS = 'ADD_SIGNIFICANT_HISTORY_SUCCESS';
export const ADD_SIGNIFICANT_HISTORY_ERROR = 'ADD_SIGNIFICANT_HISTORY_ERROR';

export function addSignificantHistory(patientId: string, significantHistory: Object) {
  return ((dispatch: Function) => {
    fetchPost(
      `${SERVER_ADDRESS}/informationHistory/addSignificantHistory`,
      {
        ...significantHistory,
        patientId,
      },
      (data) => {
        dispatch({
          type: ADD_SIGNIFICANT_HISTORY_SUCCESS,
          data,
        });
        dispatch(fetchPatientData(patientId));
      },
      (error) => {
        dispatch({
          type: ADD_SIGNIFICANT_HISTORY_ERROR,
          error: error.message || error.toString(),
        });
      },
    );
    dispatch({
      type: ADD_SIGNIFICANT_HISTORY_LOADING,
    });
  });
}

export const UPDATE_SIGNIFICANT_HISTORY_LOADING = 'UPDATE_SIGNIFICANT_HISTORY_LOADING';
export const UPDATE_SIGNIFICANT_HISTORY_SUCCESS = 'UPDATE_SIGNIFICANT_HISTORY_SUCCESS';
export const UPDATE_SIGNIFICANT_HISTORY_ERROR = 'UPDATE_SIGNIFICANT_HISTORY_ERROR';

export function updateSignificantHistory(patientId: string, significantHistory: Object) {
  return ((dispatch: Function) => {
    fetchPost(
      `${SERVER_ADDRESS}/informationHistory/updateSignificantHistory`,
      {
        ...significantHistory,
        patientId,
      },
      (data) => {
        dispatch({
          type: UPDATE_SIGNIFICANT_HISTORY_SUCCESS,
          data,
        });
        dispatch(fetchPatientData(patientId));
      },
      (error) => {
        dispatch({
          type: UPDATE_SIGNIFICANT_HISTORY_ERROR,
          error: error.message || error.toString(),
        });
      },
    );
    dispatch({
      type: UPDATE_SIGNIFICANT_HISTORY_LOADING,
    });
  });
}

export const DELETE_SIGNIFICANT_HISTORY_LOADING = 'DELETE_SIGNIFICANT_HISTORY_LOADING';
export const DELETE_SIGNIFICANT_HISTORY_SUCCESS = 'DELETE_SIGNIFICANT_HISTORY_SUCCESS';
export const DELETE_SIGNIFICANT_HISTORY_ERROR = 'DELETE_SIGNIFICANT_HISTORY_ERROR';

export function deleteSignificantHistory(patientId: string, significantHistoryId: string) {
  return ((dispatch: Function) => {
    fetchPost(
      `${SERVER_ADDRESS}/informationHistory/deleteSignificantHistory`,
      {
        significantHistoryId,
        patientId,
      },
      (data) => {
        dispatch({
          type: DELETE_SIGNIFICANT_HISTORY_SUCCESS,
          data,
        });
        dispatch(fetchPatientData(patientId));
      },
      (error) => {
        dispatch({
          type: DELETE_SIGNIFICANT_HISTORY_ERROR,
          error: error.message || error.toString(),
        });
      },
    );
    dispatch({
      type: DELETE_SIGNIFICANT_HISTORY_LOADING,
    });
  });
}

export const ADD_DIET_HISTORY_LOADING = 'ADD_DIET_HISTORY_LOADING';
export const ADD_DIET_HISTORY_SUCCESS = 'ADD_DIET_HISTORY_SUCCESS';
export const ADD_DIET_HISTORY_ERROR = 'ADD_DIET_HISTORY_ERROR';

export function addDietHistory(patientId: string, dietHistory: Object) {
  return ((dispatch: Function) => {
    fetchPost(
      `${SERVER_ADDRESS}/informationHistory/addDietHistory`,
      {
        ...dietHistory,
        patientId,
      },
      (data) => {
        dispatch({
          type: ADD_DIET_HISTORY_SUCCESS,
          data,
        });
        dispatch(fetchPatientData(patientId));
      },
      (error) => {
        dispatch({
          type: ADD_DIET_HISTORY_ERROR,
          error: error.message || error.toString(),
        });
      },
    );
    dispatch({
      type: ADD_DIET_HISTORY_LOADING,
    });
  });
}

export const UPDATE_DIET_HISTORY_LOADING = 'UPDATE_DIET_HISTORY_LOADING';
export const UPDATE_DIET_HISTORY_SUCCESS = 'UPDATE_DIET_HISTORY_SUCCESS';
export const UPDATE_DIET_HISTORY_ERROR = 'UPDATE_DIET_HISTORY_ERROR';

export function updateDietHistory(patientId: string, dietHistory: Object) {
  return ((dispatch: Function) => {
    fetchPost(
      `${SERVER_ADDRESS}/informationHistory/updateDietHistory`,
      {
        ...dietHistory,
        patientId,
      },
      (data) => {
        dispatch({
          type: UPDATE_DIET_HISTORY_SUCCESS,
          data,
        });
        dispatch(fetchPatientData(patientId));
      },
      (error) => {
        dispatch({
          type: UPDATE_DIET_HISTORY_ERROR,
          error: error.message || error.toString(),
        });
      },
    );
    dispatch({
      type: UPDATE_DIET_HISTORY_LOADING,
    });
  });
}

export const DELETE_DIET_HISTORY_LOADING = 'DELETE_DIET_HISTORY_LOADING';
export const DELETE_DIET_HISTORY_SUCCESS = 'DELETE_DIET_HISTORY_SUCCESS';
export const DELETE_DIET_HISTORY_ERROR = 'DELETE_DIET_HISTORY_ERROR';

export function deleteDietHistory(patientId: string, dietHistoryId: string) {
  return ((dispatch: Function) => {
    fetchPost(
      `${SERVER_ADDRESS}/informationHistory/deleteDietHistory`,
      {
        dietHistoryId,
        patientId,
      },
      (data) => {
        dispatch({
          type: DELETE_DIET_HISTORY_SUCCESS,
          data,
        });
        dispatch(fetchPatientData(patientId));
      },
      (error) => {
        dispatch({
          type: DELETE_DIET_HISTORY_ERROR,
          error: error.message || error.toString(),
        });
      },
    );
    dispatch({
      type: DELETE_DIET_HISTORY_LOADING,
    });
  });
}



// WEBPACK FOOTER //
// ./client/src/actions/informationHistoryActions.js